import { Link } from "react-router-dom";
import styles from "./ConditionsGrid.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import Marquee from "./Marquee";
import { conditionsGrid } from "../data/content";

/**
 * Quick self-identification: a patient arrives knowing their symptom,
 * not which discipline treats it. Each tile routes to the page that
 * actually handles it.
 *
 * Two slow-sliding rows moving in opposite directions — enough motion
 * to draw the eye without turning the section into a carousel the
 * visitor has to chase. Pauses on hover/focus; static under
 * prefers-reduced-motion.
 */
export default function ConditionsGrid() {
  const mid = Math.ceil(conditionsGrid.length / 2);
  const rows = [conditionsGrid.slice(0, mid), conditionsGrid.slice(mid)];

  const Tile = ({ c }) => (
    <Link to={c.to} className={styles.tile}>
      <span className={styles.icon}>
        <Icon name={c.icon} size={24} />
      </span>
      <span className={styles.label}>{c.label}</span>
      <Icon name="arrow" size={16} className={styles.arrow} />
    </Link>
  );

  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        <Reveal className={styles.head}>
          <p className="u-eyebrow">Conditions we treat</p>
          <h2 className={styles.heading}>Where does it hurt?</h2>
          <p className={styles.lead}>
            Pick what brought you here and go straight to how it is treated.
          </p>
        </Reveal>
      </div>

      {/* full-bleed: the rows should run past the shell's gutters */}
      <div className={styles.rows}>
        {rows.map((row, i) => (
          <Marquee
            key={i}
            speed={i === 0 ? 52 : 64}
            reverse={i === 1}
            ariaLabel={`Conditions treated, row ${i + 1}`}
          >
            {row.map((c) => (
              <Tile key={c.label} c={c} />
            ))}
          </Marquee>
        ))}
      </div>

      <div className="u-shell">
        <p className={styles.tail}>
          Not listed?{" "}
          <Link to="/conditions">See the full list of conditions</Link> or just
          describe it when you book — the assessment sorts it out.
        </p>
      </div>
    </section>
  );
}
